module.exports = __webpack_public_path__ + "img/WA.c9c738ff.png";